import type { CartLine, MysteryBucketService } from '../../types'
import type { BucketComposition } from './bucket.types'

export function bucketToCartLine(
  composition: BucketComposition,
  service?: MysteryBucketService,
): Omit<CartLine, 'quantity'> {
  if (service) {
    const cadenceLabel =
      service.cadence === 'once'
        ? 'One-off'
        : service.cadence === 'weekly'
          ? 'Weekly'
          : 'Fortnightly'
    return {
      key: `mystery-service:${service.cadence}:${service.delivery.id}:${composition.id}`,
      name:
        service.cadence === 'once'
          ? 'One-off Mystery Bucket'
          : `${cadenceLabel} Mystery Bucket`,
      priceCents:
        service.bucketSubtotalCents + service.deliveryFeeCents,
      image: '/media/higgsfield/editorial/shop-staff-guide.webp',
      detail: `${composition.name} · First drop ${service.delivery.day} ${service.delivery.date}, ${service.delivery.window}`,
      kind: 'mystery-plan',
      service,
    }
  }

  return {
    key: `bucket:${composition.id}`,
    name: composition.name,
    priceCents: composition.subtotalCents,
    image: composition.lines[0]?.image ?? '/products/pick-mix.png',
    kind: 'bucket',
  }
}
